class HeaderPanelDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.addEventListener('click', (e) => {
      if (e.target.hasAttribute('data-drawer-overlay')) {
        this.close();
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    this.closeAllOtherDrawers();

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const inner = this.querySelector('.header-panel-drawer__inner');
        const focusEl = this.querySelector('.header-panel-drawer__close') || inner;
        if (inner && typeof trapFocus === 'function') {
          trapFocus(inner, focusEl);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  closeAllOtherDrawers() {
    document.querySelectorAll('header-panel-drawer').forEach((drawer) => {
      if (drawer !== this && drawer.classList.contains('active')) {
        drawer.close();
      }
    });

    document.querySelectorAll('cart-drawer').forEach((cartDrawer) => {
      if (cartDrawer.classList.contains('active')) {
        cartDrawer.close();
      }
    });

    document.querySelectorAll('header-drawer').forEach((headerDrawer) => {
      const detailsElement = headerDrawer.querySelector('details[open]');
      if (detailsElement) {
        const summaryElement = detailsElement.querySelector('summary');
        if (summaryElement) {
          summaryElement.setAttribute('aria-expanded', 'false');
          headerDrawer.closeMenuDrawer(new Event('close'), summaryElement);
        }
      }
    });
  }
}

customElements.define('header-panel-drawer', HeaderPanelDrawer);
